module.exports = __webpack_public_path__ + "static/media/pic_fuwu.9c3dad0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageTic/pic_fuwu.png
// module id = 581
// module chunks = 0